module.exports = __webpack_public_path__ + "img/card-user-review.2250cd25.png";